// @ts-nocheck
// Call Stats — date/duration helpers and the preset date-range list.
import moment from 'moment';

export const PRESETS = [
  {
    key: 'today',
    label: 'Today',
    getRange: () => ({
      start: moment().startOf('day').toDate(),
      end: moment().endOf('day').toDate(),
    }),
  },
  {
    key: 'yesterday',
    label: 'Yesterday',
    getRange: () => ({
      start: moment().subtract(1, 'day').startOf('day').toDate(),
      end: moment().subtract(1, 'day').endOf('day').toDate(),
    }),
  },
  {
    key: 'this_week',
    label: 'This Week',
    getRange: () => ({
      start: moment().startOf('week').toDate(),
      end: moment().endOf('day').toDate(),
    }),
  },
  {
    key: 'this_month',
    label: 'This Month',
    getRange: () => ({
      start: moment().startOf('month').toDate(),
      end: moment().endOf('day').toDate(),
    }),
  },
];

const pad = (n) => String(n).padStart(2, '0');

export const formatDuration = (totalSeconds) => {
  const s = Number(totalSeconds) || 0;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  if (h > 0) return `${h}h ${pad(m)}m ${pad(sec)}s`;
  if (m > 0) return `${m}m ${pad(sec)}s`;
  return `${sec}s`;
};

export const formatDurationShort = (totalSeconds) => {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.round(s / 60)}m`;
  const h = s / 3600;
  return `${h < 10 ? h.toFixed(1).replace(/\.0$/, '') : Math.round(h)}h`;
};

export const dateToInputStr = (d) => {
  if (!d) return '';
  return moment(d).format('YYYY-MM-DD');
};

export const inputStrToLocalDate = (str) => {
  if (!str) return null;
  const parsed = moment(str, 'YYYY-MM-DD', true);
  return parsed.isValid() ? parsed.toDate() : null;
};

export function fillDailyGaps(daily, startDate, endDate) {
  const map = new Map((daily || []).map((row) => [row.date, row]));
  const result: any[] = [];
  const cursor = moment(startDate).startOf('day');
  const end = moment(endDate).startOf('day');

  while (cursor.isSameOrBefore(end)) {
    const key = cursor.format('YYYY-MM-DD');
    result.push(
      map.get(key) || {
        date: key,
        total: 0,
        answered: 0,
        failed: 0,
        abandoned: 0,
        incoming: 0,
        outgoing: 0,
        talk_time: 0,
      }
    );
    cursor.add(1, 'day');
  }
  return result;
}

export function getPeriodDateRange(periodKey) {
  switch (periodKey) {
    case 'today':
      return {
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
      };
    case 'yesterday':
      return {
        start: moment().subtract(1, 'day').startOf('day').toDate(),
        end: moment().subtract(1, 'day').endOf('day').toDate(),
      };
    case 'this_week':
      return {
        start: moment().startOf('week').toDate(),
        end: moment().endOf('day').toDate(),
      };
    default:
      return {
        start: moment().startOf('day').toDate(),
        end: moment().endOf('day').toDate(),
      };
  }
}
